import { HttpClient } from '@angular/common/http';
import { requestDataChanged, withCache } from '@ngneat/cashew';
import { Observable, catchError, of } from 'rxjs';
import { Appeal, AppealHistory, AppealStatus } from '../../models/appeal/appeal.interface';
import { Injectable } from '@angular/core';
import { AppealStatusChangeRequest } from '../../models/appeal/appeal-status-change-request.interface';
import { Action, ACTION_GROUP_CODES } from '@edassist/common';

@Injectable({ providedIn: 'root' })
export class AppealService {
	constructor(private readonly http: HttpClient) {}

    getParticipantAppealHistory(
		participantId: number
	): Observable<Array<AppealHistory>> {
		return this.http.get<Array<AppealHistory>>(
			`appeals/history?participantId=${participantId}`,{
                context: withCache({
					clearCachePredicate: requestDataChanged
				})
            }
		)
		.pipe(catchError(() => of([])));
	}
	getAppeal(
		applicationId: number
	): Observable<Array<Appeal>> {
		return this.http.get<Array<Appeal>>(
			`appeals?applicationId=${applicationId?.toString()}`
		)
	}

	getAppealStatus(): Observable<Array<AppealStatus>> {
		return this.http.get<Array<AppealStatus>>(
			`appeals/statuses`, {
				context: withCache({
					clearCachePredicate: requestDataChanged
				})
			}
		).pipe(catchError(() => of([])));
	}

	changeAppealStatus(
		appealId: number,
		statusChange: AppealStatusChangeRequest
	): Observable<any> {
		return this.http.put<any>(
			`appeals/${appealId}/status`,
			statusChange
		);
	}

	reviewAppealComment(
		commentId: string): Observable<void> {
		return this.http.put<void>(
			`appeals/comments/${commentId}/review`,
			undefined
		);
	}

	updateAppealReviewer(
		applicationId: number,
		appealId: number,
		existingReviewerId: number,
		newReviewerId: number): Observable<Appeal> {
		return this.http.put<Appeal>(
			`appeals/${appealId}/reviewer/${existingReviewerId}?applicationId=${applicationId}&newReviewerId=${newReviewerId}`,
			undefined
		);
	}

	getAppealActions(applicationId: number,
		actionCode: ACTION_GROUP_CODES
	): Observable<Array<Action>> {
		return this.http.get<Array<Action>>(
			`applications/${applicationId}/appeal-actions?groupCode=${actionCode}`
		).pipe(catchError(() => of([])));
	}
}
